export const NOTIFICATION_GROUPS = [
  'listings',
  'offers',
  'deals',
  'orders',
  'messages',
  'reservations',
  'transaction',
  'other',
] as const;

export type NotificationGroup = (typeof NOTIFICATION_GROUPS)[number];
export interface NotificationTypeTagProps {
  shortType?: string;
  fallbackType?: string;
  group?: NotificationGroup;
  size?: 'sm' | 'md';
  className?: string;
  enumValues?: string[];
}

export type EnumItem = { id?: string; value?: string };